export default "__VITE_ASSET__BTvSzlE2__"